import { EquipmentCompanyKeyItemDto } from './EquipmentCompanyKeyItemDto';

/**
 * Distinct equipment (regardless of company) with a list of { company, keyID } instances.
 */
export interface EquipmentKeyDropdownItemDto {
  name: string;
  displayName: string;
  displayNameWithVpCompanyIds?: string;
  companyKeys: EquipmentCompanyKeyItemDto[];
}
